<template>
    <v-tooltip bottom open-delay="100" v-if="isValidDate">
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ createdDate | luxonPostedAgo }}</span>
        </template>
        <span>{{ createdDate | luxonToolTipDateTime }}</span>
    </v-tooltip>
    <span v-else>
        <span>Unknown Date</span>
    </span>
</template>
<script>
export default {
    props: {
        createdDate: {
            type: String,
            required: true,
        },
    },
    computed: {
        isValidDate() {
            return this.$options.filters.luxonPostedAgo(this.createdDate) !== 'Invalid Date'
        },
    },
}
</script>
